import { render, staticRenderFns } from "./DistributorOrderRank.vue?vue&type=template&id=c765b2e4&scoped=true"
import script from "./DistributorOrderRank.vue?vue&type=script&lang=js"
export * from "./DistributorOrderRank.vue?vue&type=script&lang=js"
import style0 from "./DistributorOrderRank.vue?vue&type=style&index=0&id=c765b2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c765b2e4",
  null
  
)

export default component.exports